//import 'core-js/client/core'; // todo: попробовать отключить и проверить в IE (babel должен всё сделать)
import "core-js/stable";
import { isHostnameForHtmlEnvironment, isHostnameForBitrixEnvironment, getPublicPathForHtmlEnvironment } from '../main/utils/utils';

if (isHostnameForHtmlEnvironment(document.location.hostname)) {
    __webpack_public_path__ = getPublicPathForHtmlEnvironment(document.location.pathname);
} else if (isHostnameForBitrixEnvironment(document.location.hostname)) {
    __webpack_public_path__ = '/local/templates/.default/';
}

require('./package/browser-tests');

const raf = require('raf');
const $ = require('jquery');

window.jQuery = $;
window.$ = $;

require('slick-carousel');
require('./vendor/magnific-popup.fork');
require('nanoscroller');

if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = raf;
}

window.NLMK = window.NLMK || {};

NLMK.magnificPopupDefaults = {
    mainClass: 'mfp-fade mfp-with-zoom',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
    closeBtnInside: true,
    zoom: {
        enabled: true, // By default it's false, so don't forget to enable it
        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function
    },
};
//NLMK.GoogleMapsApiKey = 'AIzaSyBA_iM912EGpBXtRrWEl_MFsm072Mxv34g';
NLMK.FusionTablesApiKey = 'AIzaSyAm9yWCV7JPCTHCJut8whOjARd7pwROFDQ';
NLMK.GoogleMapsApiKey = NLMK.GoogleMapsApiKey || 'AIzaSyANLiSH02TkHWQS0F-SxzhweJg_zcq-IA4';
//NLMK.FusionTablesApiKey = 'AIzaSyANLiSH02TkHWQS0F-SxzhweJg_zcq-IA4';

NLMK.TRANSITION_DURATION = 300;
NLMK.ESC_CODE = 27;
NLMK.xmlns = 'http://www.w3.org/2000/svg';
NLMK.xlink = 'http://www.w3.org/1999/xlink';

/**
 *
 * @param {boolean} condition
 * @param {string} errorMessage
 */
NLMK.validate = function validate(condition, errorMessage) {
    if (typeof condition !== 'boolean') {
        throw new Error('condition must be a boolean');
    } else if (typeof errorMessage !== 'string') {
        throw new Error('errorMessage must be a string');
    }

    if (console.assert) {
        console.assert(condition, errorMessage);
    } else if (!condition) {
        throw new Error(errorMessage);
    }

    return true;
};

if (!NLMK.templatePath) {
    NLMK.templatePath = './';
}

NLMK.logging = window.localStorage ? 'true' === localStorage.getItem('logging') : false;
NLMK.logTracing = window.localStorage ? 'true' === localStorage.getItem('logTracing') : false;

NLMK.enableLogging = function enableLogging() {
    NLMK.logging = true;

    window.localStorage && localStorage.setItem('logging', NLMK.logging);
};

NLMK.enableLogTracing = function enableLogTracing() {
    NLMK.logTracing = true;

    window.localStorage && localStorage.setItem('logTracing', NLMK.logTracing);
};

NLMK.log = function log(...args) {
    if (NLMK.logging && window.console) {
        ((NLMK.logTracing ? console.trace : console.log) || console.log).call(console, ...args);
    }
};

NLMK.i18n = require('./package/i18n');
NLMK.translations = require('./package/i18n').translations;

NLMK.mediaQueries = {
    mobile: { min: 0, max: 767.9 },
    verticalTablet: { min: 768, max: 1023.9 },
    horizontalTablet: { min: 1024, max: 1399.9 },
    desktop: { min: 1400, max: 1880.9 },
    fullhd: { min: 1881, max: 9000 },
};

NLMK.mediaQueries.isMobile = () => innerWidth <= NLMK.mediaQueries.mobile.max;

NLMK.getCurrentAdaptiveName = function getCurrentAdaptiveName() {
    if (innerWidth <= NLMK.mediaQueries.mobile.max) {
        return 'mobile';
    } else if (
        innerWidth >= NLMK.mediaQueries.verticalTablet.min &&
        innerWidth <= NLMK.mediaQueries.verticalTablet.max
    ) {
        return 'verticalTablet';
    } else if (
        innerWidth >= NLMK.mediaQueries.horizontalTablet.min &&
        innerWidth <= NLMK.mediaQueries.horizontalTablet.max
    ) {
        return 'horizontalTablet';
    } else if (innerWidth >= NLMK.mediaQueries.desktop.min && innerWidth <= NLMK.mediaQueries.desktop.max) {
        return 'desktop';
    } else if (innerWidth >= NLMK.mediaQueries.fullhd.min && innerWidth <= NLMK.mediaQueries.fullhd.max) {
        return 'fullhd';
    }
};

/**
 *
 * @param {string} [theme] "dark" or "light"
 */
NLMK.triggerHeadTheme = function triggerHeadTheme(theme) {
    $(window).trigger('trigger-head-theme', theme);
};

/**
 *
 * @returns {string}
 */
NLMK.generateTemplatePath = function generateTemplatePath(path) {
    return (NLMK.templatePath + '/' + path).replace(/\/\//gi, '/');
};

/**
 *
 * @param {string} direction
 * @param {string} slickDirection
 * @param {string} arrow
 * @returns {string}
 */
NLMK.generateSlickArrow = function generateSlickArrow(direction, slickDirection, arrow = 'arrow-v3') {

    return `<button type="button" class="slick-arrow slick-${slickDirection} js-hover">
                <svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-${direction}">
                    <use xlink:href="#svg-symbol--${arrow}-${direction}"/>
                </svg>
            </button>`;
};

require('./package/events');
require('./package/utils');
// require('./package/google-maps');
require('./package/fusion-tables');
require('./package/toggle-scroll');

require('./plugin/once');
require('./plugin/debounce');
require('./plugin/throttle');
require('./plugin/jquery.repeat');
require('./plugin/interval-while');
require('./plugin/data-background-image');
require('./plugin/jquery.touchSwipe.min');
require('./plugin/turn.min');
require('./plugin/scissor.min');
require('./plugin/zoom.min');

// swiper slider
import Swiper from './plugin/swiper';
window.Swiper = Swiper;

/**
 *
 * @param {number} time ms
 * @param {function} func callback
 * @param {object|undefined} bindContext
 * @returns {function} throttledAndDebounced
 */
$.throttleAndDebounce = function throttleAndDebounce(time, func, bindContext) {
    const debounced = $.debounce(time, func);
    const throttled = $.throttle(time, func);

    return function throttledAndDebounced(...args) {
        debounced.apply(bindContext, args);
        throttled.apply(bindContext, args);
    };
};

require('./plugin/adaptive-background');
require('./plugin/hover-backgrounds');
require('./plugin/in-viewport');
require('./plugin/jquery.or');
require('./plugin/jquery.text-max-length');
require('./plugin/jquery.flexdatalist');

// swiper slider
require('./module/sliders/company-swiper');
require('./module/sliders/welcome-swiper');
require('./module/sliders/reports-swiper');

// require('./module/toggle-map.js');
require('./module/scroll-top');
require('./module/section-reports');
require('./module/section-widgets');
require('./module/section-tabs');
require('./module/sliders/slider');
require('./module/sliders/mobile');
require('./module/sliders/widgets');
require('./module/dropdown');
require('./module/events');
require('./module/sliders/welcome'); // async
require('./module/sliders/quotes');
require('./module/sliders/vTabletMobile');
require('./module/tabs');
require('./module/simple-tabs');
require('./module/filter');
require('./module/select'); // async
require('./module/sliders/media');
require('./module/form-validation'); // async
require('./module/head');
require('./module/persona');
require('./module/geography'); // async
require('./module/map'); // async
require('./module/sliders/leader');
require('./module/sliders/company');
require('./module/sliders/strategy');
require('./module/sliders/titled');
require('./module/sliders/simple');
require('./module/accordion');
require('./module/datepicker'); // async
require('./module/js-touch-tip');
require('./module/js-sidebar');
require('./module/universal-tabs');
require('./module/group-structure');
require('./module/distribution'); // async
require('./module/sliders/history');
require('./module/sliders/welcome-history'); // async
require('./module/sliders/welcome-product'); // async
require('./module/sliders/mobile-tabs');
require('./module/sliders/single-carousel');
require('./module/modal-html-gallery');
require('./module/graphic-scheme');
require('./module/tippy'); // async
require('./module/tiles');
require('./module/block-title-toggle');
require('./module/switchable-chip');
require('./module/table-filter');
require('./module/share'); // async
require('./module/field-nested');
require('./module/add-template');
require('./module/remove-action');
require('./module/add-file');
require('./module/masked-input'); // async
require('./module/file-input');// async
require('./module/select-box-range');
require('./module/scrollable-x'); // async
require('./module/clear-filter');
require('./module/form-privacy');
require('./module/data-href');
require('./module/scroll-block-x.js');
require('./module/governance-scheme');
require('./module/governance-structure');
require('./module/js-geography');
require('./module/popup');
require('./module/chart'); //async
require('./module/media-popup');
require('./module/advanced-search');
require('./module/readonly');
require('./module/box-circle-preloader');

require('./page/five-years-results'); // async
require('./page/ecology-indicators'); // async

require('./module/flipbook');
require('./module/popover');
require('./module/lazyload');
require('./module/nanoscroller');
require('./module/img-object-fit');
require('./module/audioplayer');
require('./module/input-box');
require('./module/videohosting-player');
require('./module/swiper-carousel');
require('./module/free-gallery') // async
require('./module/header-search-bar') // async

$(document)
    .on('click', '.js-click-toggle-class', (evt) => {
        const $toggler = $(evt.currentTarget);
        const targetSelector = $toggler.data('click-toggle-class-target');
        const className = evt.currentTarget.dataset.clickToggleClass;

        let $target = $toggler;

        if (targetSelector) {
            $target = $(targetSelector);
        }

        $target.toggleClass('active', className);
    })
    .on(NLMK.TOUCHSTART_EVENT, '.touch-tip-container', function onTouchStart() {
        $(this)
            .find('.touch-tip')
            .remove();
    });

// fix sidebar
setTimeout(() => {
    window.stickySidebar && window.stickySidebar.updateSticky();
    // window.stickySidebar.updateSticky();
}, 60);



// WEBPACK FOOTER //
// ./js/main/index.js